<!--
 * @Description: 成品代加工费
 * @Author: wangwangwang
 * @Date: 2020-09-21 14:09:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-29 14:58:19
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div class="header_right" @click="showCardNav = !showCardNav">
          <div class="title">搜索</div>
          <div>
            <div :class="{ 'arrowTransform': !showCardNav, 'arrowTransformReturn': showCardNav}">
              <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
            </div>
          </div>
        </div>
        <div v-show="showCardNav" class="hr"></div>
        <el-collapse-transition>
          <div v-show="showCardNav">
            <div class="search">
              <span style="display: inline-block;margin-bottom: 10px;">
                <span style="margin-right: 12px;">公司</span>
                <el-select v-model="tableParam.company" placeholder="请选择">
              <el-option v-for="item in companyIdList" :key="item.id" :label="item.name" :value="item.name"></el-option>
            </el-select>
              </span>
              <span style="margin-left: 24px;">
                <span style="margin-right: 12px;">时间</span>
                <el-date-picker v-model="datePicker" style="height:36px" type="datetimerange" unlink-panels align="right" start-placeholder="开始时间" end-placeholder="结束时间" :default-time="['12:00:00', '08:00:00']" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
              </span>
              <el-button icon="el-icon-search" size="medium" class="bottom_all but1" @click="(tableParam.page = 1), gettableData()">查 询</el-button>
              <el-button size="medium" class="bottom_all_two" @click="init()">重 置</el-button>
            </div>
          </div>
        </el-collapse-transition>
        <div class="hr"></div>
        <div class="card">
          <div class="card_nav">
            <div>
              <el-button @click="addFromDate('添加')">
                <i class="icon iconfont iconicon_button_add" style="font-size: 12px;"></i>
                添加
              </el-button>
            </div>
          </div>
          <div v-loading="tableLoading" class="card_info">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width:100%" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange">
              <el-table-column align="center" type="selection"></el-table-column>
              <template v-for="(item, index2) in table">
                <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :min-width="item.width" :fixed=" (item.label =='操作'||item.label =='二维码')?'right':false">
                  <template slot-scope="scope">
                    <span v-if="item.label == '操作' ">
                      <el-button  class="bottom_one" size="mini" @click="deleteProduct(scope.row.id)">
                      删除
                    </el-button>
                    </span>
                    <span v-else>{{ scope.row[item.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize" :page-sizes="[10, 20, 30, 40,50,100,200,500,1000]" layout="prev,pager,sizes,next,jumper" :total="total" @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <el-dialog v-dialogDrag :visible.sync="addDialog" width="580px" :close-on-click-modal="false" :before-close="resetFromDate">
      <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
      <div class="dialoginfo">
        <el-form ref="reffromDate" style="padding: 20px;" :rules="rules" :inline="true" :model="fromDate" label-width="110px">
          <el-form-item prop="companyId">
            <span slot="label" style="color:  #FF0000 ;">公司</span>
            <el-select ref="companyId" v-model="fromDate.companyId" placeholder="请选择" @change="$nextTick(()=>{(fromDate.company = $refs.companyId.selectedLabel)})">
              <el-option v-for="item in companyIdList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="startTime">
            <span slot="label" style="color:  #FF0000 ;">生效时间</span>
            <el-date-picker v-model="fromDate.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
          </el-form-item>
          <el-form-item prop="nomalPrice">
            <span slot="label" style="color:  #FF0000 ;">正常生产单价（元/吨）</span>
            <el-input v-model="fromDate.nomalPrice" placeholder="请输入" oninput="if(value.length > 11 ){ value = value.slice(0,11)}" onkeypress='return( /\d|\./.test(String.fromCharCode(event.keyCode)))' @input="fromDate.nomalPrice=$regExp.checkNum(fromDate.nomalPrice)" @blur="fromDate.nomalPrice=$regExp.blurCheckNum(fromDate.nomalPrice)">
            </el-input>
          </el-form-item>
          <el-form-item prop="returnPrice">
            <span slot="label" style="color:  #FF0000 ;">返料生产单价（元/吨）</span>
            <el-input v-model="fromDate.returnPrice" placeholder="请输入" oninput="if(value.length > 11 ){ value = value.slice(0,11)}" onkeypress='return( /\d|\./.test(String.fromCharCode(event.keyCode)))' @input="fromDate.returnPrice=$regExp.checkNum(fromDate.returnPrice)" @blur="fromDate.returnPrice=$regExp.blurCheckNum(fromDate.returnPrice)">
            </el-input>
          </el-form-item>
          <el-form-item prop="scale">
            <span slot="label" style="color:  #FF0000 ;">不收加工费比例（%）</span>
            <el-input v-model="fromDate.scale" placeholder="请输入" oninput="if(value.length > 11 ){ value = value.slice(0,11)}" onkeypress='return( /\d|\./.test(String.fromCharCode(event.keyCode)))' @input="fromDate.scale=$regExp.checkNum(fromDate.scale)" @blur="fromDate.scale=$regExp.blurCheckNum(fromDate.scale)">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetFromDate">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px;" @click="pagessubmitFromDate()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import {
  queryPage,
  deleteProcessingFee,
  saveOrUpdate,
  queryJurisdictionCompanyList,
} from "@/api/smart/specialmaterial/productProcessing.js";
export default {
  mixins: [mixin],
  data() {
    return {
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      saveOrUpdate: saveOrUpdate,
      /*表格数据*/
      table: [
        {
          label: "公司",
          width: "120",
          prop: "company",
          status: true,
        },
        {
          label: "生效时间",
          width: "100",
          prop: "startTime",
          status: true,
        },
        {
          label: "正常生产单价（元/吨）",
          width: "120",
          prop: "nomalPrice",
          status: true,
        },
        {
          label: "返料生产单价（元/吨）",
          width: "160",
          prop: "returnPrice",
          status: true,
        },
        {
          label: "不收加工费比例",
          width: "100",
          prop: "scale",
          status: true,
        },
        {
          label: "操作",
          width: "100",
          prop: "",
          status: true,
        },
      ],
      /*添加表单数据*/
      rules: {
        companyId: [
          { required: true, message: "请选择公司", trigger: "change" },
        ],
        startTime: [
          { required: true, message: "请选择生效时间", trigger: "change" },
        ],
        nomalPrice: [
          { required: true, message: "请输入正常生产单价", trigger: "change" },
        ],
        returnPrice: [
          { required: true, message: "请输入返料生产单价", trigger: "change" },
        ],
        scale: [{ required: true, message: "请输入不收加工费比例", trigger: "change" }],
      },
      fromDate: {
        company: "",
        companyId: "",
        nomalPrice: "",
        returnPrice: "",
        scale: "",
        startTime: "",
      },
      companyIdList: [],
      datePicker:[],
    };
  },
  watch:{
     /**时间选择*/
    datePicker() {
      if (this.datePicker) {
        this.tableParam.createTime = this.datePicker[0]
        this.tableParam.updateTime = this.datePicker[1]
      } else {
        this.tableParam.createTime = ''
        this.tableParam.updateTime = ''
      }
    },
  },
  async created() {
    queryJurisdictionCompanyList().then(res => {
      if(res.code == 1001) {
        this.companyIdList = res.data
      }
    })
    this.tableParam = { ...this.tableParam, company: "", createTime: "",updateTime:"" };
    this.gettableData();
  },
  /*
   *copy(data)深拷贝数据,返回拷贝完的数据
   *gettableData获取列表数据
   *load下载
   *SortNum保持序列号
   * UpdateOrDelete禁用，启用，删除
   * submitFromDate保存更新数据
   */
  methods: {
    deleteProduct(id){
      this.$confirm('确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        cancelButtonClass: 'bottom_all_two',
        confirmButtonClass: 'bottom_all',
        type: 'warning'
      }).then(() => {
        deleteProcessingFee({id:id}).then(res => {
        if(res.code == 1001) {
          this.$message.success('删除成功!')
          this.gettableData()
        }
      })
      })
      
    },
    pagessubmitFromDate() {
      let _this = this;
      _this.$refs.reffromDate.validate((valid) => {
        if (valid) {
          _this.submitFromDate();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    init() {
      /*重置数据*/
      this.tableParam.company = "";
      this.tableParam.createTime = "";
      this.tableParam.updateTime = "";
      this.gettableData();
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.dialoginfo {
  .el-input,
  .el-select {
    width: 280px;
  }
}
.table_link {
  margin: 0 0 0 10px;
  border: $bg_color 1px solid;
  color: $bg_color;
  border-radius: 3px;
  font-size: 14px;
  height: 30px;
  background: #ffffff;
  a {
    display: inline-block;
    line-height: 29.31px;
    color: $bg_color;
    text-decoration: none;
    font-size: 14px;
  }
}
</style>
